import { useUiStore } from '@/state/uiStore';

/**
 * Time-of-day slider. Drives `lights.setSun(0..1)` which moves the
 * directional light along an arc and re-tints both the key light and the
 * hemisphere. 0 = sunrise, 0.5 = midday, 1 = sunset.
 */
export function SunSlider() {
  const sun = useUiStore((s) => s.sun);
  const setSun = useUiStore((s) => s.setSun);

  const label = (() => {
    if (sun < 0.15) return 'sunrise';
    if (sun < 0.4) return 'morning';
    if (sun < 0.6) return 'midday';
    if (sun < 0.85) return 'evening';
    return 'sunset';
  })();

  return (
    <div className="sun panel">
      <div className="label">Sun</div>
      <input
        type="range"
        min={0}
        max={1}
        step={0.01}
        value={sun}
        onChange={(e) => setSun(Number(e.target.value))}
        aria-label="Time of day (sun position)"
        aria-valuetext={label}
      />
      <div className="label sun-caption">{label}</div>
    </div>
  );
}
